module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"coupons":{"sub_title":"利用可能なクーポン一覧","expires_at":"有効期限：{0} まで","unlimited":"有効期限：期限なし"},"button":"マイクーポンを見る","hint":"※クーポンの有効期限のタイミングによっては、すでに失効したクーポンが表示される場合があります。「マイクーポンを見る」ボタンをクリックすると、より正確な情報を確認できます。"}}')
  delete Component.options._Ctor
}
